import { createAction, handleActions } from 'redux-actions';

const setProcurementItems = createAction("SCREENS/ORDER_VIEW/SET_PROCUREMENT_ITEMS");
const addProcurementItem = createAction("SCREENS/ORDER_VIEW/ADD_PROCUREMENT_ITEM");
const updateProcurementItem = createAction("SCREENS/ORDER_VIEW/UPDATE_PROCUREMENT_ITEM");
const removeProcurementItem = createAction("SCREENS/ORDER_VIEW/REMOVE_PROCUREMENT_ITEM");

const defaultState = [];

const reducer = handleActions(
  {
    [setProcurementItems]: (state, action) => action.payload,
    [addProcurementItem]: (state, action) => [...state, action.payload],
    [updateProcurementItem]: (state, action) => state.map(item => 
      item.id === action.payload.id ? action.payload : item
    ),
    [removeProcurementItem]: (state, action) => {
      // If payload is a number, treat it as index; otherwise treat as ID
      if (typeof action.payload === 'number') {
        return state.filter((item, index) => index !== action.payload);
      }
      return state.filter(item => item.id !== action.payload);
    },
    'RESET_ORDER_VIEW': () => defaultState,
  },
  defaultState
);

export { setProcurementItems, addProcurementItem, updateProcurementItem, removeProcurementItem, reducer };
